import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

const VerticalTabs = ({
  tabs,
  defaultTab = 0,
  activeColor = "primary", //primary,success,danger,warning,info,invoiced,leave,draft
  activeVariant = "contained", //contained, outlined, text
  onTabChange, // new
  minWidth = "min-w-[200px]",
}) => {
  const activeStyles = {
    contained: `bg-${activeColor}-100 text-black border-b border-neutrals-200`,
    outlined: `text-${activeColor} border-b border-${activeColor}`,
    text: `text-${activeColor} border-b border-neutrals-200`,
  };
  const navigate = useNavigate();
  const [activeMainTab, setActiveMainTab] = useState(defaultTab);

  const handleTabClick = useCallback(
    (item, index, isMainTab = true) => {
      if (isMainTab) {
        setActiveMainTab(index);
        if (onTabChange) {
          onTabChange(item);
        }
      }
    },
    [navigate, onTabChange]
  );

  return (
    <div role="tablist" className="tab-container flex flex-1">
      <div className=" grid grid-cols-[2fr_10fr] p-1 gap-3 flex-1">
        <div className={`flex flex-col`}>
          <div
            className={`flex flex-col shadow rounded-lg overflow-auto ${minWidth}`}
          >
            {tabs.map((item, key) => (
              <div
                key={key}
                className={`flex items-center gap-3 py-3 px-2 cursor-pointer ${activeMainTab === key
                    ? activeStyles[activeVariant]
                    : `border-b border-neutrals-200`
                  }`}
                onClick={() => handleTabClick(item, key)}
              >
                <span>{item.title}</span>
                {item.value && (
                  <span className="bg-dark rounded text-xs text-white px-1">
                    {item.value}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>

        <div
          role="tabpanel"
          className="tab-content flex flex-1 shadow rounded-lg overflow-auto"
        >
          {tabs[activeMainTab]?.page &&
            // <div className="flex flex-1 flex-col">
            React.cloneElement(tabs[activeMainTab].page, {
              setActiveTab: setActiveMainTab,
            })}
        </div>
      </div>
    </div>
  );
};

export default VerticalTabs;
